import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: t('securePaymentTitle'),
      description: t('securePaymentDesc'),
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: t('instantActivationTitle'),
      description: t('instantActivationDesc'),
      color: 'from-green-500 to-green-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('support247Title'),
      description: t('support247Desc'),
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-wallet-3-line',
      title: t('multiplePaymentTitle'),
      description: t('multiplePaymentDesc'),
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: 'ri-speed-line',
      title: t('highSpeedTitle'),
      description: t('highSpeedDesc'),
      color: 'from-cyan-500 to-blue-600'
    },
    {
      icon: 'ri-global-line',
      title: t('easyAccessTitle'),
      description: t('easyAccessDesc'),
      color: 'from-pink-500 to-rose-600'
    }
  ];

  return (
    <div className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('whyChooseUs')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('whyChooseUsDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
